//================= [JS] ======================================
import {i18n} from '@/common/i18n';
import {Routes} from '@/common/enums/Routes';
import {Permissions} from '@simpleforyou/coaching-shared';
//================= [VUE COMPONENTS] ==========================

export const settingsRoutes = [
  {
    path: i18n.global.t('routes.settings'),
    name: Routes.SETTINGS,
    component: () => import('@/components/settings/CustomerSettings.vue'),
    meta: {
      title: i18n.global.t('titles.settings'),
      active: 'settings',
      roles: [Permissions.ROLE_CUSTOMER_SETTINGS_INDEX],
    },
  },
];
